import axios from "./BaseService";

export const getAlerts = async () => {
  return axios.get("/alerts?pageSize=100&includeItems=true&status=active").then((res) => {
    return res.data.results;
  });
};
